<template>
    <div class="body">
        <div class="head">
            <div class="school-info">
                <el-image
                        style="width: 80px; height: 80px"
                        fit="contain"
                        :src="schoolInfo.logo">
                </el-image>
                <span class="school-span">
                  {{schoolInfo.name}} | 微+项目
                </span>
            </div>
            <div class="class-name">{{className}}</div>
            <div class="time">{{nowTime[0]}} {{nowTime[2]}} {{nowTime[1]}}</div>
        </div>
        <div class="box">
            <div class="box-l">
                <div class="box-l1">
                    <div class="title">活动通知</div>
                    <el-empty description="暂无数据" v-if="noticeData.length==0"></el-empty>
                    <div class="notice box-b">
                        <div v-for="(item,index) in noticeData" :key="index" @click="artClick(item)">
                            <p class="notice-title">{{item.title}}</p>
                            <p class="notice-time">{{item.createTime}}</p>
                        </div>
                    </div>
                </div>
                <div class="box-l2">
                    <div class="title">评比动态</div>
                    <div class="formData box-b">
                        <el-empty description="暂无数据" v-if="formDataList.length==0"></el-empty>
                        <div class="dataList" v-for="(item,index) in formDataList" :key="index">
                            <div class="dataList-l">
                                <div class="dataList-time">{{item.currentProcessIdTime}}</div>
                                <div class="text">
                                    <span class="name">{{item.createPersonName}} {{item.className}}</span> 在 <span>"{{item.evaluateContentName}}"</span>
                                    <span v-if="item.prizeName">活动中获得</span>{{item.prizeName}}
                                </div>
                            </div>
                            <div class="prize">
                                <el-image
                                        style="width: 120px; height: 120px"
                                        fit="contain"
                                        :src="item.prizeImage||item.imageUrl">
                                </el-image>
                            </div>
                            <div class="num" v-if="item.propNum">x{{item.propNum}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-r">
                <div class="box-r-head">
                    <div class="head-title">精彩时刻</div>
                    <div class="tabs">
                        <span class="head-tab tab-home" @click="btnClick(1)">首页</span>
                        <span class="head-tab tab-btn" @click="btnClick(2)" v-if="query.page>1">上一页</span>
                        <span class="head-tab tab-btn" @click="btnClick(3)" v-if="nextPage">下一页</span>
                    </div>
                </div>
                <div class="wonderful">
                    <el-empty description="暂无数据" v-if="wonderfulList.length==0"></el-empty>
                    <div class="wonderful-box" v-for="(item,index) in wonderfulList" :key="index">
                        <div class="wonderful-time">{{item.time}}</div>
                        <div class="wonderful-image" ref="bannerHeight">
                            <el-carousel indicator-position="none" :height="bannerHeight+'px'" v-if="item.images">
                                <el-carousel-item v-for="items in item.images" :key="items">
                                    <img :src="items">
                                </el-carousel-item>
                            </el-carousel>
                            <img :src="item.prizeImage" v-else>
                        </div>
                        <div class="wonderful-cont"><span>{{item.createPersonName}} </span> 参加
                            "{{item.evaluateContentName}}"
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div :class="articleShow?'article':'hidden'">
            <el-button type="danger" class="closeBtn" @click="closeArticle">关闭</el-button>
            <div class="article-title">{{showItem.title}}</div>
            <div class="article-time">{{showItem.createTime}}</div>
            <div v-html="showItem.content" class="article-content box-b"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "schoolProject",
        data() {
            return {
                bannerHeight:'',

                nowTime: [],
                classId: '',
                schoolId: '',
                className: '',
                nowDate: '',

                noticeData: [],
                formDataList: [],
                wonderfulList: [],
                query: {
                    page: 1,
                    size: 3
                },
                nextPage: true,
                articleShow: false,
                showItem: {},

                schoolInfo: {}
            }
        },
        created() {
            this.classId = this.$route.query.classId
            this.schoolId = this.$route.query.schoolId
            this.getSchoolInfo()
            this.getClass()
            this.nowDate = this.$util.getNowDate()
            this.nowTimes()

            this.getClassNotice()
            this.getList()
            this.getWonderful()
        },
        mounted() {
            window.addEventListener('resize',()=>{
                this.bannerHeight=this.$refs.bannerHeight[0].offsetHeight
                this.imgLoad()
            },false)
        },
        methods: {
            timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
                let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
                let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
                let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
                let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
                this.nowTime = [];
                this.nowTime.push(year + "年" + month + "月" + date + '日');
                this.nowTime.push(hh + ":" + mm + ':' + ss);
                let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
                this.nowTime.push(weeks[timeStamp.getDay()]);
            },
            nowTimes() {
                this.timeFormate(new Date());
                setInterval(this.nowTimes, 1000);
                this.clear()
            },
            clear() {
                clearInterval(this.nowTimes)
                this.nowTimes = null;
            },

            getSchoolInfo() {
                let url = "/zuhu1/api-dashboard/school/findOne"
                let query = {
                    openid: 'abc',
                    schoolId: this.schoolId,
                }
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        this.schoolInfo = response.data.data
                    }
                })
            },
            getClass() {
                let url = "/zuhu1/api-dashboard/class/findById"
                this.$api.post(url, {classId: this.classId}, response => {
                    if (response.data.result == "success") {
                        this.className = response.data.data.className
                    }
                })
            },

            // 活动通知

            getClassNotice() {
                let url = "/zuhu1/api-dashboard/classNotice/page_"
                let query = {
                    categoryName: "微+活动通知",
                    openid: 'abc',
                    schoolId: this.schoolId,
                }
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        this.noticeData = response.data.data || []
                    }
                })
            },


            getList() {
                let url = "/zuhu1/api-dashboard/evaluateContentProcessFormData/list"
                let query = {
                    openid: 'abc',
                    schoolId: this.schoolId,
                    classId: this.classId,
                    orderBy:"currentProcessIdTime"
                }
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data || []
                        datas.map(item => {
                            item.imageUrl = item.images ? item.images[0] : ''
                        })
                        this.formDataList = datas
                    }
                })
            },
            getWonderful() {
                let url = "/zuhu1/api-dashboard/evaluateContentProcessFormData/list"
                let query = {
                    openid: 'abc',
                    schoolId: this.schoolId,
                    teacherEvaluateResult: '精彩推荐',
                    page: this.query.page,
                    size: this.query.size,
                    classId: this.classId,
                    orderBy:"currentProcessIdTime"
                }
                if(this.query.lastId){
                    query.lastId=this.query.lastId
                }
                if(this.query.firstId){
                    query.firstId=this.query.firstId
                }
                this.$api.post(url, query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data || []
                        datas.map(item => {
                            item.imageUrl = item.images ? item.images[0] : ''
                            item.time=item.currentProcessIdTime.substring(5,11)
                        })
                        this.wonderfulList = datas
                        if (datas.length < 4) {
                            this.nextPage = false
                        } else {
                            this.nextPage = true
                        }
                        this.imgLoad();
                    }
                })
            },
            btnClick(type) {
                let page = this.query.page
                this.query.firstId = ''
                this.query.lastId = ''
                switch (type * 1) {
                    case 1:
                        page = 1
                        break;
                    case 2:
                        page = page - 1
                        this.query.firstId = this.wonderfulList[0].id
                        break;
                    case 3:
                        page = page + 1
                        this.query.lastId = this.wonderfulList[this.wonderfulList.length - 1].id
                        break;
                }
                this.query.page = page
                this.getWonderful()
            },

            artClick(item) {
                this.articleShow = true
                this.showItem = item
            },
            closeArticle() {
                this.articleShow = false
                this.showItem = {}
            },

            imgLoad(){
                this.$nextTick(()=>{
                    this.bannerHeight=this.$refs.bannerHeight[0].offsetHeight
                })
            }

        }
    }
</script>

<style scoped>
    .body {
        background: #0F40F5;
        width: 100%;
        height: 100%;
        background-image: url(../../assets/imgs/classStatisticsImgs/bodybg.jpg);
        background-repeat: no-repeat;
    }

    .head {
        color: white;
        display: flex;
        /*justify-content: space-between;*/
        height: 100px;
        line-height: 100px;
    }

    .head > div {
        padding: 0 24px;
        flex: 1;
    }

    .class-name {
        font-size: 36px;
        text-align: center;
        font-weight: bold;
    }

    .school-info {
        font-size: 24px;
        display: flex;
        align-items: center;
    }

    .school-span {
        padding: 0 20px;
        font-weight: bold;
    }

    .time {
        font-size: 24px;
        text-align: right;
        font-weight: bold;
    }

    .box {
        box-sizing: border-box;
        padding: 0 40px 40px;
        height: calc(100% - 100px);
        display: flex;
        justify-content: space-between;
    }

    .box-l {
        flex: 2;
        /*display: flex;*/
        /*flex-direction: column;*/
        margin-right: 20px;
    }

    .box-l1 {
        /*flex: 1;*/
        height: 49%;
        margin-bottom: 2%;
        background: white;
        border-radius: 15px;
    }

    .notice, .formData {
        height: calc(100% - 60px);
        overflow: auto;
    }

    .notice > div {
        background: rgb(240, 240, 240);
        border-radius: 20px;
        min-height: 80px;
        line-height: 80px;
        color: rgb(5, 5, 7);
        display: flex;
        justify-content: space-between;
        width: 90%;
        margin: 10px auto;
        padding: 0 20px;
        font-size: 22px;
    }

    .notice-title {
        width: calc(100% - 220px);
    }

    .notice-time {
        width: 220px;
    }

    .formData {
        padding: 0 20px;
    }

    .dataList {
        display: flex;
        border-bottom: 1px dotted rgb(100, 100, 100);
        padding: 20px 0;
    }

    .dataList-l {
        flex: 1;
    }

    .dataList-time {
        background: rgb(109, 151, 229);
        color: white;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 15px;
        padding: 0 10px;
        display: inline-block;
    }

    .text {
        font-size: 20px;
        padding: 10px 0;
    }

    .text .name {
        font-size: 22px;
        font-weight: bold;
    }

    .prize {
        width: 120px;
        height: 120px;
    }

    .prize > image {
        width: 100%;
        height: 100%;
    }

    .num {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
    }


    .box-l2 {
        height: 49%;
        background: white;
        border-radius: 20px;
    }

    .box-r {
        flex: 3;
        background: white;
        border-radius: 20px;
    }

    .title {
        font-size: 28px;
        font-weight: bold;
        text-align: center;
        height: 60px;
        line-height: 60px;
    }

    .box-b::-webkit-scrollbar {
        width: 4px;
    }

    .box-b::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(0, 92, 225, 0.5);
    }


    .box-r-head {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
    }

    .head-title {
        font-size: 28px;
        font-weight: bold;
        height: 60px;
        line-height: 60px;
    }

    .wonderful {
        height: calc(100% - 60px);
        padding: 0 20px;
    }

    .wonderful-box {
        display: inline-block;
        background: rgb(240, 240, 240);
        border-radius: 20px;
        width: 48%;
        height: 45%;
        margin: 1%;
    }

    .wonderful-time {
        color: rgb(79, 79, 79);
        font-size: 18px;
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        text-align: right;
        font-weight: bold;
    }

    .wonderful-image {
        width: 90%;
        margin: auto;
        height: calc(100% - 100px);
        overflow: hidden;
    }

    .wonderful-image  img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .wonderful-cont {
        text-align: center;
        color: rgb(86, 86, 86);
        font-size: 18px;
        height: 60px;
        line-height: 60px;
    }

    .tabs {
        display: flex;
        align-items: center;
    }

    .head-tab {
        display: inline-block;
        padding: 5px 10px;
        border-radius: 5px;
        margin: 0 10px;
    }
    .head-tab:active {
        background-color: #629AD8; /* 更深的绿色背景 */
        color: white;
    }

    .tab-home {
        background: #629AD8;
        color: #D6EDF9;
    }

    .tab-btn {
        background: #B0D9F9;
        color: #5F82AC;
    }

    .hidden {
        display: none;
    }

    .article {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: white;
        padding: 0 40px;
        box-sizing: border-box;
    }

    .closeBtn {
        position: absolute;
        top: 20px;
        right: 20px;

    }

    .article-title {
        font-size: 28px;
        font-weight: bold;
        text-align: center;
        padding: 20px;
    }

    .article-time {
        font-size: 18px;
        color: #999;
        text-align: center;
    }

    .article-content {
        height: calc(100% - 110px);
        overflow: auto;
    }
</style>

